module.exports = __webpack_public_path__ + "static/media/entersect.bcdb5de2.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/entersect.ico
// module id = 1910
// module chunks = 0